import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const PublicRoute = () => {
	const isAuthenticated = localStorage.getItem("is_authenticated");
	const location = useLocation();

	const publicPaths = ["/", "/home", "/home/professor-profile/", "/callback"];

	const isPublicPath = publicPaths.some(
		(path) =>
			location.pathname === path || location.pathname.startsWith("/home")
	);

	if (isPublicPath) {
		return <Outlet />;
	}

	if (isAuthenticated === "true") {
		const role = localStorage.getItem("role");
		return <Navigate to={`/${role}/dashboard`} replace />;
	}

	return <Outlet />;
};

export default PublicRoute;
